import React from 'react';

const Placeholder = ({ pageName }) => {
  return (
    <div className="card">
      <h2 className="card-title">{pageName}</h2>
      <p style={{color: '#6B7280', marginTop: '20px'}}>
        This page is under construction. Content will be added soon.
      </p>
    </div>
  );
};

export default Placeholder;